@if (!defaultOpen) {
  <div class="schedule-configuration">
    <div class="text-muted">Default Availability is configured to: <span class="schedule-configuration-value">Closed</span></div>
  </div>
}
